// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/scrollbars.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Attached-agent chat panel, styled to the approved concept screens
   (png-concepts/03 + 06) and the "Chat feedback visual system" contract in
   docs/03-ui-decisions.md: grouped surfaces (--curio-surface-muted), hairline
   borders (--curio-border), 12px radii, raised card-bg inner panels, dark
   right-aligned user
   bubbles, avatar-prefixed agent rows, soft chips, 16px gutters. */

/* Full-height right drawer flush with the viewport top (portal to <body>):
   the dark header sits at the top-bar level, like the concept and the roster
   drawer. Above the main top menu (z 100–200), below the roster drawer's
   backdrop (z 1200). */
.YSZGpjeZyMO8o4qSlaGn {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  /* Catalog-drawer sizing parity (memo dev/46): the Agent Catalog panel's
     exact dimensions, in the same scale family as the Nodes/Datasets
     drawers. Content scales (85% bubbles, min-width:0 columns). */
  width: 560px;
  max-width: 92vw;
  z-index: 1100;
  display: flex;
  flex-direction: column;
  background: var(--curio-card-bg, var(--curio-card-bg));
  border-left: 1px solid var(--curio-border, var(--curio-border));
  box-shadow: -8px 0 24px rgba(0, 0, 0, 0.18);
  overflow: hidden;
  /* Slides in from the right, on the same curve and duration as the three
     catalog drawers (#295). The panel already claimed "catalog-drawer sizing
     parity" above and was the one right-hand surface in the product that
     appeared and vanished instantly - which read as a glitch beside its peers,
     and made a detach look like the whole panel had crashed rather than
     closed. Keep in step with \`.drawer\` in CatalogDrawerShell.module.css and
     with DRAWER_MOTION_MS in useSlideDrawerPresentation. */
  transform: translate3d(100%, 0, 0);
  transition: transform 300ms cubic-bezier(0.32, 0.72, 0, 1);
  will-change: transform;
}

.nfvdcfpsDwsC0InnAKu5 {
  transform: translate3d(0, 0, 0);
}

@media (prefers-reduced-motion: reduce) {
  .YSZGpjeZyMO8o4qSlaGn {
    transition-duration: 0.01ms;
  }
}

/* ── header (DEC-042, dev/21): ONE dark top header for the opened agent view —
   the ‹ › cycling arrows, agent identity, session details, and Close. No Pin,
   and no static "Agent Catalog" bar (that chrome is roster-drawer-only). ── */
.hcY4HNioE016YOlKn9TF {
  display: flex;
  flex-direction: column;
  gap: 6px;
  /* Flush with the viewport top; the extra top padding optically aligns the
     identity row with the adjacent main top bar. */
  padding: 14px 12px 12px;
  background: var(--curio-top-bar-bg, var(--curio-top-bar-bg));
  color: var(--curio-text-on-dark, var(--curio-text-on-dark));
}

.Ghsu5p0srgAfVNes7LW_ {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.hC4TH1jb7Kw9NiLCq7Qg {
  flex: 1;
}

.kGDpMf5kb8cufXJUtGAh {
  flex: none;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 6px;
  background: none;
  color: var(--curio-text-muted);
  font-size: 12px;
  cursor: pointer;
}

.kGDpMf5kb8cufXJUtGAh:hover:not(:disabled),
.kGDpMf5kb8cufXJUtGAh:focus-visible {
  background: var(--curio-top-bar-bg-hover);
  color: var(--curio-text-on-dark);
}

.kGDpMf5kb8cufXJUtGAh:disabled {
  color: var(--curio-text-secondary);
  cursor: default;
}

.gRmdxq5C6qa9qFO3qbZ_ {
  flex: none;
  font-size: 16px;
  color: var(--curio-role-running-fg); /* overridden by a category tint class */
  display: flex;
  align-items: center;
}

.sEDXNWYcDyPV3R7gHPHb {
  flex: none;
  font-size: 11px;
  color: var(--curio-text-meta);
}

/* Category tints — same palette as AgentAvatarBadge (icon color, white chip). */
.ROsXntDDUq291fOK6cK9     { color: var(--curio-category-agent-node-fg); }
.n7odiLlAHn_EDh7TrCJb   { color: var(--curio-category-agent-canvas-fg); }
.pertikFcLQSEZELlqjp9     { color: var(--curio-category-agent-data-fg); }
.XYjBtr3GyfUTMav2I65K { color: var(--curio-category-agent-evaluate-fg); }
.jMWwV1J1MWEgWx9mZXgb  { color: var(--curio-category-agent-package-fg); }

.jv1q9hWT8uKWu3gg_KYf {
  font-size: 13px;
  font-weight: 600;
  color: var(--curio-text-on-dark, var(--curio-text-on-dark));
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

/* ── click-to-rename conversation title (memo dev/25): the affordance is the
   title itself — hover underline, no edit button or icon. ── */
.wjvsEW93W1MvoGCGqMOr {
  border: none;
  background: none;
  padding: 0;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
}

.wjvsEW93W1MvoGCGqMOr:hover,
.wjvsEW93W1MvoGCGqMOr:focus-visible {
  text-decoration: underline dotted;
  text-underline-offset: 3px;
}

._uyNmBqH16EQLFXnD2jo {
  display: inline-flex;
  align-items: center;
  flex: 1;
  overflow: visible;
}

/* The fixed "<name>: " prefix rendered beside the editable custom portion. */
.rvhyVV791zndiyOpJVQ9 {
  flex: none;
  white-space: pre;
}

.mB6z0aiwpgqzq0S_Biie {
  flex: 1;
  min-width: 0;
  border: none;
  border-radius: 6px;
  padding: 1px 6px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  background: var(--curio-top-bar-bg-hover);
  color: var(--curio-text-on-dark, var(--curio-text-on-dark));
}

.mB6z0aiwpgqzq0S_Biie:focus {
  outline: 2px solid var(--curio-accent-sky-fg, var(--curio-focus-ring));
  outline-offset: 1px;
}

/* Rename failure: soft status tone on the dark header, subtitle row. */
.o4TRbjIGJytS6ijRZLKd {
  flex: none;
  font-size: 11px;
  color: var(--curio-danger);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Vpks_Ns38nT2a9I90hm4 {
  font-size: 11px;
  color: var(--curio-text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.lY9CkUqBuGkk7QjaNnQA {
  flex: none;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 8px;
  background: none;
  color: var(--curio-text-muted);
  font-size: 13px;
  cursor: pointer;
}

.lY9CkUqBuGkk7QjaNnQA:hover,
.lY9CkUqBuGkk7QjaNnQA:focus-visible {
  background: var(--curio-top-bar-bg-hover);
  color: var(--curio-text-on-dark, var(--curio-text-on-dark));
}

/* ── initial intent, rendered as the conversation's first message ── */
.eL_q5QPwTakj5jbYZWLd {
  align-self: flex-end;
  max-width: 85%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}

.kf8sGySUbjzTBSwwticY {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Missing prompt asset: same bubble, muted. */
.tigkENMNqSFTl7_jyrC6 {
  font-style: italic;
  opacity: 0.8;
}

._ii0qpujfcKI4vvFxnKv {
  display: flex;
  align-items: center;
  gap: 6px;
}

.g53jZyXBAlPWheofvZ4w {
  border: none;
  background: none;
  padding: 0;
  font-size: 11px;
  font-weight: 600;
  color: var(--curio-accent-sky-fg, var(--curio-role-running-fg));
  cursor: pointer;
}

.Wln8T1ZRFGLfqRY5QehG {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 6px;
  background: none;
  color: var(--curio-text-secondary, var(--curio-text-meta));
  font-size: 11px;
  cursor: pointer;
}

.Wln8T1ZRFGLfqRY5QehG:hover,
.Wln8T1ZRFGLfqRY5QehG:focus-visible {
  background: var(--curio-surface-muted);
  color: var(--curio-text-primary, var(--curio-text-primary));
}

.v_RzWbnJ7rgB99vlaQml {
  align-self: stretch;
}

.RfHe9sRQvsyDV67Watm6 {
  width: 100%;
  min-height: 88px;
  resize: vertical;
  background: var(--curio-card-bg);
  border: 1px solid var(--curio-border);
  border-radius: 12px;
  padding: 10px 12px;
  font-size: 12px;
  line-height: 1.45;
  font-family: inherit;
  color: var(--curio-text-primary, var(--curio-text-primary));
  box-sizing: border-box;
}

.RfHe9sRQvsyDV67Watm6:focus {
  outline: 2px solid var(--curio-accent-sky-fg, var(--curio-focus-ring));
  outline-offset: 1px;
}

.xfu3ojXS36aNANOUcQAN {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  align-items: center;
}

.W9SdFsg7riAVDlzfYDtA {
  border: none;
  border-radius: 999px;
  padding: 5px 14px;
  font-size: 11px;
  font-weight: 600;
  background: var(--curio-accent-sky-fg, var(--curio-role-running-fg));
  color: var(--curio-text-on-dark);
  cursor: pointer;
}

.W9SdFsg7riAVDlzfYDtA:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.UEtDp7giFHR32Kpcg9kl {
  border: 1px solid var(--curio-border);
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 11px;
  font-weight: 600;
  background: var(--curio-card-bg);
  color: var(--curio-text-primary, var(--curio-text-primary));
  cursor: pointer;
}

.wNctfAPfjlfyph4OpPoJ {
  font-size: 11px;
  color: var(--curio-danger-text);
}

/* ── transcript: grouped surface with bubbles / agent rows ── */
/* Positioning context for the Jump-to-latest overlay (memo dev/75): the pill
   anchors to this box, not the scroller, so it doesn't scroll with content. */
.juGm_zDGKQ7gSjWxCklf {
  position: relative;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.HzxkNAL9uzS7QF0aH0LP {
  flex: 1;
  /* A flex child won't shrink below its content without this, so the
     transcript would grow past the clipped panel and never scroll. */
  min-height: 0;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: var(--curio-surface-muted);
}

/* Programmatically focusable (tabindex="-1") as the Jump pill's focus
   fallback — no visible ring for that non-interactive focus. */
.HzxkNAL9uzS7QF0aH0LP:focus {
  outline: none;
}

.nAuyJD9v4phORomRzk7Z {
  align-self: flex-end;
  max-width: 85%;
  padding: 8px 12px;
  border-radius: 12px;
  font-size: 12.5px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
  background: var(--curio-top-bar-bg, var(--curio-top-bar-bg));
  color: var(--curio-text-on-dark, var(--curio-text-on-dark));
}

/* The clamp's \`overflow: hidden\` clips at the padding box, so the bubble's
   vertical padding showed the top half of the fifth line (#502). A
   transparent border takes the padding's place: the background still runs
   under it, and the clip falls right under the fourth line. */
.nAuyJD9v4phORomRzk7Z.kf8sGySUbjzTBSwwticY {
  padding-top: 0;
  padding-bottom: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
}

/* A message someone else wrote, in a chat the owner and the editors the owner
   invited share: its writer's name above the bubble, in the meta line's quiet
   type. Your own messages carry no name. */
.ywED5rzAFo4cki8cTklz {
  align-self: flex-end;
  max-width: 85%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
}

.ywED5rzAFo4cki8cTklz .nAuyJD9v4phORomRzk7Z {
  max-width: 100%;
}

.ARmNvfV8bVxth0gmMvH9 {
  padding-right: 2px;
  font-size: 11px;
  line-height: 1.4;
  color: var(--curio-text-secondary, var(--curio-text-meta));
}

.ReODflKISrUwjY_iYWqT {
  align-self: flex-start;
  display: flex;
  gap: 8px;
  max-width: 92%;
}

/* Bubble + per-reply status meta stacked beside the avatar (dev/80 amd.). */
.VmE69ReXgamHN_hiKdfO {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
  flex: 1;
}

/* Per-reply execution status (dev/80 amendment): a quiet line under the
   bubble — running while the reply streams, then duration + tokens. */
.E0WwEtVOrndrB_qv2IwG {
  padding-left: 2px;
}

/* A line that stays under one reply, in the meta line's quiet type: why a
   tool call failed, or that a canvas agent changed nothing on the canvas. */
.FBcFVbVJzqV1EPzg0xUv {
  padding-left: 2px;
  font-size: 11px;
  line-height: 1.4;
  color: var(--curio-text-secondary, var(--curio-text-meta));
  overflow-wrap: anywhere;
}

/* The skills a reply's run held or loaded: the quietest of the lines under a
   reply, each name in the type the docs give a skill's name. */
.hruLuzu069u26XbI5prw {
  color: var(--curio-text-muted, var(--curio-text-meta));
}

.ZJQOtwLf1cgHA_QPLBhu {
  font-family: var(--curio-font-mono, ui-monospace, monospace);
  font-size: 10.5px;
}

.JncX5AIR2d5vpJDhcKj7 {
  flex: none;
  width: 22px;
  height: 22px;
  margin-top: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  border: 1px solid var(--curio-border);
  background: var(--curio-card-bg);
  font-size: 11px;
}

/* Agent text: raised white inner panel on the grouped surface. */
.BpuQM2TNgLbhdUGJlJa9 {
  width: 100%;
  padding: 8px 12px;
  border-radius: 12px;
  border: 1px solid var(--curio-border);
  background: var(--curio-card-bg);
  font-size: 12.5px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
  color: var(--curio-text-primary, var(--curio-text-primary));
}

/* Soft status tone for failures — gentle fill + hairline, never saturated. */
.Bljkh8Q5pbofbH_HbAvg {
  background: var(--curio-danger-bg);
  border-color: var(--curio-danger-border);
  color: var(--curio-danger-strong);
}

.T_HDqO5dhga3rYOpoNWd {
  align-self: center;
  font-size: 11px;
  color: var(--curio-text-secondary, var(--curio-text-meta));
  text-align: center;
  padding: 2px 10px;
}

.XodwB4s04VQvpk8tQTvK {
  background: var(--curio-danger-bg);
  border: 1px solid var(--curio-danger-border);
  border-radius: 999px;
  color: var(--curio-danger-strong);
}

.D0ipVLSnmkuGeXde2QSy {
  border: none;
  background: none;
  padding: 0 0 0 6px;
  font-size: 11px;
  font-weight: 600;
  color: var(--curio-accent-sky-fg, var(--curio-role-running-fg));
  cursor: pointer;
}

/* ── footer: pill input + circular accent send ── */
.qQm0wGQY9m9OpaU2GuVX {
  /* The anchor of the list \`/\` opens above the composer. */
  position: relative;
  display: flex;
  gap: 8px;
  /* Bottom-anchored so the send button stays beside the last line as the
     multiline composer grows (memo dev/77). */
  align-items: flex-end;
  padding: 12px 16px;
  background: var(--curio-card-bg, var(--curio-card-bg));
  border-top: 1px solid var(--curio-border);
}

/* The skills \`/\` lists, above the composer, as wide as its row. */
.pi3FjmBWpItxDcLZtXLE {
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: calc(100% + 4px);
  z-index: 2;
  max-height: 240px;
  overflow-y: auto;
  padding: 4px;
  background: var(--curio-card-bg);
  border: 1px solid var(--curio-border);
  border-radius: 10px;
  box-shadow: var(--curio-shadow-context-menu);
}

.HIkphSQez0JcidGxqFZi {
  padding: 8px 10px;
  font-size: 11.5px;
  color: var(--curio-text-secondary, var(--curio-text-meta));
}

.VlBanzeirXAAnq2_SMgU {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 10px;
  border-radius: 7px;
  cursor: pointer;
}

.dBbbMCmbLJDPEZXH0G6F {
  background: var(--curio-surface-muted);
}

.z1o1aJUpJl00m89aZQqw {
  font-family: var(--curio-font-mono, ui-monospace, monospace);
  font-size: 11.5px;
  font-weight: 600;
  color: var(--curio-text-primary);
}

.o8QgVPGe5a4V6RE4U5gf {
  font-family: var(--curio-font-family);
  font-weight: 400;
  color: var(--curio-text-muted, var(--curio-text-meta));
}

.xoEDhPU3QOTPZXhdmKRY {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-size: 11px;
  line-height: 1.35;
  color: var(--curio-text-secondary, var(--curio-text-meta));
}

.bDAyWVGQ9UaIy5jjyJet {
  flex: 1;
  min-width: 0;
  padding: 9px 14px;
  border: 1px solid var(--curio-border);
  /* Half the one-row height: renders as the same pill at a single line, a
     rounded rectangle once the textarea grows — never a distorted stadium. */
  border-radius: 18px;
  font-size: 12.5px;
  font-family: inherit;
  line-height: 1.45;
  background: var(--curio-surface-muted);
  color: var(--curio-text-primary, var(--curio-text-primary));
  /* Growth is content-driven (useAutoGrowTextarea) — no manual drag handle,
     no scrollbar until the height cap is reached. */
  resize: none;
  overflow-y: hidden;
}

.bDAyWVGQ9UaIy5jjyJet:focus {
  outline: 2px solid var(--curio-accent-sky-fg, var(--curio-focus-ring));
  outline-offset: 1px;
  background: var(--curio-card-bg);
}

._0vRb9JnW7kK8IleEWWyg {
  flex: none;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: var(--curio-accent-sky-fg, var(--curio-role-running-fg));
  color: var(--curio-text-on-dark);
  font-size: 13px;
  cursor: pointer;
}

._0vRb9JnW7kK8IleEWWyg:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ── structured content (memo dev/39) ──────────────────────────────────── */

/* Markdown from the safe renderer: keep the bubble rhythm tight. */
.BpuQM2TNgLbhdUGJlJa9 p {
  margin: 0 0 6px;
}
.BpuQM2TNgLbhdUGJlJa9 p:last-child {
  margin-bottom: 0;
}
.BpuQM2TNgLbhdUGJlJa9 pre {
  background: var(--curio-card-bg);
  border: 1px solid var(--curio-border);
  border-radius: 8px;
  padding: 8px 10px;
  overflow-x: auto;
  font-size: 0.8rem;
}
.BpuQM2TNgLbhdUGJlJa9 code {
  font-size: 0.82em;
}

/* SUGGESTED PROMPTS chips (docs/03 soft-token treatment): filled soft
   surfaces with hairlines, above the input row. */
.TTqCzDniUREUnT0HKGHA {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 8px 16px 0;
  background: var(--curio-card-bg, var(--curio-card-bg));
  border-top: 1px solid var(--curio-border);
}

.pbV4FlOheKlgSgjL0h89 {
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--curio-text-meta);
  margin-right: 2px;
}

.KsE0ANGSTPR43M6Ki0iA {
  border: 1px solid var(--curio-border);
  background: var(--curio-surface-muted);
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 0.78rem;
  color: var(--curio-text-primary);
  cursor: pointer;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.KsE0ANGSTPR43M6Ki0iA:hover,
.KsE0ANGSTPR43M6Ki0iA:focus-visible {
  background: var(--curio-surface-muted);
  border-color: var(--curio-border-strong);
}

/* The chips row visually joins the footer beneath it. */
.TTqCzDniUREUnT0HKGHA + .qQm0wGQY9m9OpaU2GuVX {
  border-top: none;
}

/* ── counter strip (memo dev/80, amended): the session's accumulated token
   total, right-aligned by the composer (per-reply statuses live on the
   messages). Fixed height so appearing/updating causes no layout shift. */
.cOUYa2kuTn7DwORzkbaX {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 24px;
  padding: 3px 16px;
  background: var(--curio-card-bg, var(--curio-card-bg));
  border-top: 1px solid var(--curio-border);
}

.MbmRdKAmSUyuEskyUfOm {
  flex: 1;
}

/* The strip joins whatever sits directly beneath/above it into one block. */
.TTqCzDniUREUnT0HKGHA + .cOUYa2kuTn7DwORzkbaX,
.cOUYa2kuTn7DwORzkbaX + .qQm0wGQY9m9OpaU2GuVX {
  border-top: none;
}

/* ⚙ Attachment settings cog (memo dev/42) — a quiet labeled control at the
   top of the content area, beneath the DEC-042 header. */
.tAreghSZSdseEyysHdSv {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid var(--curio-border);
  background: var(--curio-surface-muted);
  border-radius: 8px;
  padding: 5px 12px;
  font-size: 0.76rem;
  color: var(--curio-text-secondary);
  cursor: pointer;
  min-height: 28px;
}

.tAreghSZSdseEyysHdSv:hover,
.tAreghSZSdseEyysHdSv:focus-visible {
  background: var(--curio-surface-muted);
  border-color: var(--curio-border-strong);
  color: var(--curio-text-primary);
}
`, "",{"version":3,"sources":["webpack://./src/components/agents/attach/AgentChatPanel.module.css"],"names":[],"mappings":"AAAA;;;;;mEAKmE;;AAEnE;;;uBAGuB;AACvB;EACE,eAAe;EACf,QAAQ;EACR,MAAM;EACN,SAAS;EACT;;kEAEgE;EAChE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,sDAAsD;EACtD,+DAA+D;EAC/D,2CAA2C;EAC3C,gBAAgB;EAChB;;;;;;2DAMyD;EACzD,kCAAkC;EAClC,0DAA0D;EAC1D,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;;8EAE8E;AAC9E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR;mDACiD;EACjD,uBAAuB;EACvB,4DAA4D;EAC5D,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,mCAAmC,EAAE,wCAAwC;EAC7E,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,6BAA6B;AAC/B;;AAEA,gFAAgF;AAChF,4BAAiB,0CAA0C,EAAE;AAC7D,0BAAiB,4CAA4C,EAAE;AAC/D,4BAAiB,0CAA0C,EAAE;AAC7D,wBAAiB,8CAA8C,EAAE;AACjE,yBAAiB,6CAA6C,EAAE;;AAEhE;EACE,eAAe;EACf,gBAAgB;EAChB,2DAA2D;EAC3D,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;+DAC+D;AAC/D;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,OAAO;EACP,iBAAiB;AACnB;;AAEA,6EAA6E;AAC7E;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yCAAyC;EACzC,2DAA2D;AAC7D;;AAEA;EACE,sEAAsE;EACtE,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;EACE,UAAU;EACV,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,yCAAyC;EACzC,2DAA2D;AAC7D;;AAEA,uEAAuE;AACvE;EACE,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,+DAA+D;EAC/D,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,0DAA0D;EAC1D,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,sCAAsC;EACtC,2DAA2D;AAC7D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,2DAA2D;EAC3D,sBAAsB;AACxB;;AAEA;EACE,sEAAsE;EACtE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oEAAoE;EACpE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,2DAA2D;EAC3D,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,gEAAgE;AAChE;8EAC8E;AAC9E;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP;qEACmE;EACnE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sCAAsC;AACxC;;AAEA;+DAC+D;AAC/D;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,4DAA4D;EAC5D,2DAA2D;AAC7D;;AAEA;;;8DAG8D;AAC9D;EACE,cAAc;EACd,iBAAiB;EACjB,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;;2CAE2C;AAC3C;EACE,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,OAAO;AACT;;AAEA;sEACsE;AACtE;EACE,iBAAiB;AACnB;;AAEA;4EAC4E;AAC5E;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0DAA0D;EAC1D,uBAAuB;AACzB;;AAEA;+DAC+D;AAC/D;EACE,sDAAsD;AACxD;;AAEA;EACE,4DAA4D;EAC5D,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;AACjB;;AAEA,iEAAiE;AACjE;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,2DAA2D;AAC7D;;AAEA,6EAA6E;AAC7E;EACE,kCAAkC;EAClC,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,0DAA0D;EAC1D,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;EAC5C,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+DAA+D;EAC/D,eAAe;AACjB;;AAEA,oDAAoD;AACpD;EACE,yDAAyD;EACzD,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR;8CAC4C;EAC5C,qBAAqB;EACrB,kBAAkB;EAClB,sDAAsD;EACtD,yCAAyC;AAC3C;;AAEA,kEAAkE;AAClE;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0DAA0D;AAC5D;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,qCAAqC;EACrC;6EAC2E;EAC3E,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,sCAAsC;EACtC,2DAA2D;EAC3D;oDACkD;EAClD,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sEAAsE;EACtE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,oEAAoE;EACpE,gCAAgC;EAChC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,6EAA6E;;AAE7E,mEAAmE;AACnE;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;kDACkD;AAClD;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,sDAAsD;EACtD,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA,wDAAwD;AACxD;EACE,gBAAgB;AAClB;;AAEA;;0EAE0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,sDAAsD;EACtD,yCAAyC;AAC3C;;AAEA;EACE,OAAO;AACT;;AAEA,4EAA4E;AAC5E;;EAEE,gBAAgB;AAClB;;AAEA;yDACyD;AACzD;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,sCAAsC;EACtC,wCAAwC;EACxC,gCAAgC;AAClC","sourcesContent":["/* Attached-agent chat panel, styled to the approved concept screens\n   (png-concepts/03 + 06) and the \"Chat feedback visual system\" contract in\n   docs/03-ui-decisions.md: grouped surfaces (--curio-surface-muted), hairline\n   borders (--curio-border), 12px radii, raised card-bg inner panels, dark\n   right-aligned user\n   bubbles, avatar-prefixed agent rows, soft chips, 16px gutters. */\n\n/* Full-height right drawer flush with the viewport top (portal to <body>):\n   the dark header sits at the top-bar level, like the concept and the roster\n   drawer. Above the main top menu (z 100–200), below the roster drawer's\n   backdrop (z 1200). */\n.panel {\n  position: fixed;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  /* Catalog-drawer sizing parity (memo dev/46): the Agent Catalog panel's\n     exact dimensions, in the same scale family as the Nodes/Datasets\n     drawers. Content scales (85% bubbles, min-width:0 columns). */\n  width: 560px;\n  max-width: 92vw;\n  z-index: 1100;\n  display: flex;\n  flex-direction: column;\n  background: var(--curio-card-bg, var(--curio-card-bg));\n  border-left: 1px solid var(--curio-border, var(--curio-border));\n  box-shadow: -8px 0 24px rgba(0, 0, 0, 0.18);\n  overflow: hidden;\n  /* Slides in from the right, on the same curve and duration as the three\n     catalog drawers (#295). The panel already claimed \"catalog-drawer sizing\n     parity\" above and was the one right-hand surface in the product that\n     appeared and vanished instantly - which read as a glitch beside its peers,\n     and made a detach look like the whole panel had crashed rather than\n     closed. Keep in step with `.drawer` in CatalogDrawerShell.module.css and\n     with DRAWER_MOTION_MS in useSlideDrawerPresentation. */\n  transform: translate3d(100%, 0, 0);\n  transition: transform 300ms cubic-bezier(0.32, 0.72, 0, 1);\n  will-change: transform;\n}\n\n.panelPresented {\n  transform: translate3d(0, 0, 0);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .panel {\n    transition-duration: 0.01ms;\n  }\n}\n\n/* ── header (DEC-042, dev/21): ONE dark top header for the opened agent view —\n   the ‹ › cycling arrows, agent identity, session details, and Close. No Pin,\n   and no static \"Agent Catalog\" bar (that chrome is roster-drawer-only). ── */\n.header {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  /* Flush with the viewport top; the extra top padding optically aligns the\n     identity row with the adjacent main top bar. */\n  padding: 14px 12px 12px;\n  background: var(--curio-top-bar-bg, var(--curio-top-bar-bg));\n  color: var(--curio-text-on-dark, var(--curio-text-on-dark));\n}\n\n.headerRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.headerSpacer {\n  flex: 1;\n}\n\n.cycleBtn {\n  flex: none;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 6px;\n  background: none;\n  color: var(--curio-text-muted);\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.cycleBtn:hover:not(:disabled),\n.cycleBtn:focus-visible {\n  background: var(--curio-top-bar-bg-hover);\n  color: var(--curio-text-on-dark);\n}\n\n.cycleBtn:disabled {\n  color: var(--curio-text-secondary);\n  cursor: default;\n}\n\n.headerBot {\n  flex: none;\n  font-size: 16px;\n  color: var(--curio-role-running-fg); /* overridden by a category tint class */\n  display: flex;\n  align-items: center;\n}\n\n.position {\n  flex: none;\n  font-size: 11px;\n  color: var(--curio-text-meta);\n}\n\n/* Category tints — same palette as AgentAvatarBadge (icon color, white chip). */\n.tint_node     { color: var(--curio-category-agent-node-fg); }\n.tint_canvas   { color: var(--curio-category-agent-canvas-fg); }\n.tint_data     { color: var(--curio-category-agent-data-fg); }\n.tint_evaluate { color: var(--curio-category-agent-evaluate-fg); }\n.tint_package  { color: var(--curio-category-agent-package-fg); }\n\n.title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--curio-text-on-dark, var(--curio-text-on-dark));\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n/* ── click-to-rename conversation title (memo dev/25): the affordance is the\n   title itself — hover underline, no edit button or icon. ── */\n.titleButton {\n  border: none;\n  background: none;\n  padding: 0;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  text-align: left;\n  cursor: pointer;\n}\n\n.titleButton:hover,\n.titleButton:focus-visible {\n  text-decoration: underline dotted;\n  text-underline-offset: 3px;\n}\n\n.titleEditing {\n  display: inline-flex;\n  align-items: center;\n  flex: 1;\n  overflow: visible;\n}\n\n/* The fixed \"<name>: \" prefix rendered beside the editable custom portion. */\n.titlePrefix {\n  flex: none;\n  white-space: pre;\n}\n\n.titleInput {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  border-radius: 6px;\n  padding: 1px 6px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  background: var(--curio-top-bar-bg-hover);\n  color: var(--curio-text-on-dark, var(--curio-text-on-dark));\n}\n\n.titleInput:focus {\n  outline: 2px solid var(--curio-accent-sky-fg, var(--curio-focus-ring));\n  outline-offset: 1px;\n}\n\n/* Rename failure: soft status tone on the dark header, subtitle row. */\n.titleError {\n  flex: none;\n  font-size: 11px;\n  color: var(--curio-danger);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.subtitle {\n  font-size: 11px;\n  color: var(--curio-text-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.headerBtn {\n  flex: none;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 8px;\n  background: none;\n  color: var(--curio-text-muted);\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.headerBtn:hover,\n.headerBtn:focus-visible {\n  background: var(--curio-top-bar-bg-hover);\n  color: var(--curio-text-on-dark, var(--curio-text-on-dark));\n}\n\n/* ── initial intent, rendered as the conversation's first message ── */\n.intentMsg {\n  align-self: flex-end;\n  max-width: 85%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n}\n\n.intentClamped {\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Missing prompt asset: same bubble, muted. */\n.intentPlaceholder {\n  font-style: italic;\n  opacity: 0.8;\n}\n\n.intentControls {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.intentToggle {\n  border: none;\n  background: none;\n  padding: 0;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--curio-accent-sky-fg, var(--curio-role-running-fg));\n  cursor: pointer;\n}\n\n.intentEdit {\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 6px;\n  background: none;\n  color: var(--curio-text-secondary, var(--curio-text-meta));\n  font-size: 11px;\n  cursor: pointer;\n}\n\n.intentEdit:hover,\n.intentEdit:focus-visible {\n  background: var(--curio-surface-muted);\n  color: var(--curio-text-primary, var(--curio-text-primary));\n}\n\n.intentEditor {\n  align-self: stretch;\n}\n\n.intentTextarea {\n  width: 100%;\n  min-height: 88px;\n  resize: vertical;\n  background: var(--curio-card-bg);\n  border: 1px solid var(--curio-border);\n  border-radius: 12px;\n  padding: 10px 12px;\n  font-size: 12px;\n  line-height: 1.45;\n  font-family: inherit;\n  color: var(--curio-text-primary, var(--curio-text-primary));\n  box-sizing: border-box;\n}\n\n.intentTextarea:focus {\n  outline: 2px solid var(--curio-accent-sky-fg, var(--curio-focus-ring));\n  outline-offset: 1px;\n}\n\n.intentActions {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n  align-items: center;\n}\n\n.intentSave {\n  border: none;\n  border-radius: 999px;\n  padding: 5px 14px;\n  font-size: 11px;\n  font-weight: 600;\n  background: var(--curio-accent-sky-fg, var(--curio-role-running-fg));\n  color: var(--curio-text-on-dark);\n  cursor: pointer;\n}\n\n.intentSave:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.intentCancel {\n  border: 1px solid var(--curio-border);\n  border-radius: 999px;\n  padding: 4px 12px;\n  font-size: 11px;\n  font-weight: 600;\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary, var(--curio-text-primary));\n  cursor: pointer;\n}\n\n.intentError {\n  font-size: 11px;\n  color: var(--curio-danger-text);\n}\n\n/* ── transcript: grouped surface with bubbles / agent rows ── */\n/* Positioning context for the Jump-to-latest overlay (memo dev/75): the pill\n   anchors to this box, not the scroller, so it doesn't scroll with content. */\n.messagesWrap {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.messages {\n  flex: 1;\n  /* A flex child won't shrink below its content without this, so the\n     transcript would grow past the clipped panel and never scroll. */\n  min-height: 0;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  background: var(--curio-surface-muted);\n}\n\n/* Programmatically focusable (tabindex=\"-1\") as the Jump pill's focus\n   fallback — no visible ring for that non-interactive focus. */\n.messages:focus {\n  outline: none;\n}\n\n.msgUser {\n  align-self: flex-end;\n  max-width: 85%;\n  padding: 8px 12px;\n  border-radius: 12px;\n  font-size: 12.5px;\n  line-height: 1.45;\n  white-space: pre-wrap;\n  word-break: break-word;\n  background: var(--curio-top-bar-bg, var(--curio-top-bar-bg));\n  color: var(--curio-text-on-dark, var(--curio-text-on-dark));\n}\n\n/* The clamp's `overflow: hidden` clips at the padding box, so the bubble's\n   vertical padding showed the top half of the fifth line (#502). A\n   transparent border takes the padding's place: the background still runs\n   under it, and the clip falls right under the fourth line. */\n.msgUser.intentClamped {\n  padding-top: 0;\n  padding-bottom: 0;\n  border-top: 8px solid transparent;\n  border-bottom: 8px solid transparent;\n}\n\n/* A message someone else wrote, in a chat the owner and the editors the owner\n   invited share: its writer's name above the bubble, in the meta line's quiet\n   type. Your own messages carry no name. */\n.userTurn {\n  align-self: flex-end;\n  max-width: 85%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 3px;\n}\n\n.userTurn .msgUser {\n  max-width: 100%;\n}\n\n.msgWriter {\n  padding-right: 2px;\n  font-size: 11px;\n  line-height: 1.4;\n  color: var(--curio-text-secondary, var(--curio-text-meta));\n}\n\n.agentRow {\n  align-self: flex-start;\n  display: flex;\n  gap: 8px;\n  max-width: 92%;\n}\n\n/* Bubble + per-reply status meta stacked beside the avatar (dev/80 amd.). */\n.agentCol {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n  flex: 1;\n}\n\n/* Per-reply execution status (dev/80 amendment): a quiet line under the\n   bubble — running while the reply streams, then duration + tokens. */\n.turnMeta {\n  padding-left: 2px;\n}\n\n/* A line that stays under one reply, in the meta line's quiet type: why a\n   tool call failed, or that a canvas agent changed nothing on the canvas. */\n.turnNote {\n  padding-left: 2px;\n  font-size: 11px;\n  line-height: 1.4;\n  color: var(--curio-text-secondary, var(--curio-text-meta));\n  overflow-wrap: anywhere;\n}\n\n/* The skills a reply's run held or loaded: the quietest of the lines under a\n   reply, each name in the type the docs give a skill's name. */\n.turnSkills {\n  color: var(--curio-text-muted, var(--curio-text-meta));\n}\n\n.turnSkill {\n  font-family: var(--curio-font-mono, ui-monospace, monospace);\n  font-size: 10.5px;\n}\n\n.agentRowAvatar {\n  flex: none;\n  width: 22px;\n  height: 22px;\n  margin-top: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  border: 1px solid var(--curio-border);\n  background: var(--curio-card-bg);\n  font-size: 11px;\n}\n\n/* Agent text: raised white inner panel on the grouped surface. */\n.msgAgent {\n  width: 100%;\n  padding: 8px 12px;\n  border-radius: 12px;\n  border: 1px solid var(--curio-border);\n  background: var(--curio-card-bg);\n  font-size: 12.5px;\n  line-height: 1.45;\n  white-space: pre-wrap;\n  word-break: break-word;\n  color: var(--curio-text-primary, var(--curio-text-primary));\n}\n\n/* Soft status tone for failures — gentle fill + hairline, never saturated. */\n.msgError {\n  background: var(--curio-danger-bg);\n  border-color: var(--curio-danger-border);\n  color: var(--curio-danger-strong);\n}\n\n.systemLine {\n  align-self: center;\n  font-size: 11px;\n  color: var(--curio-text-secondary, var(--curio-text-meta));\n  text-align: center;\n  padding: 2px 10px;\n}\n\n.systemError {\n  background: var(--curio-danger-bg);\n  border: 1px solid var(--curio-danger-border);\n  border-radius: 999px;\n  color: var(--curio-danger-strong);\n}\n\n.retry {\n  border: none;\n  background: none;\n  padding: 0 0 0 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--curio-accent-sky-fg, var(--curio-role-running-fg));\n  cursor: pointer;\n}\n\n/* ── footer: pill input + circular accent send ── */\n.footer {\n  /* The anchor of the list `/` opens above the composer. */\n  position: relative;\n  display: flex;\n  gap: 8px;\n  /* Bottom-anchored so the send button stays beside the last line as the\n     multiline composer grows (memo dev/77). */\n  align-items: flex-end;\n  padding: 12px 16px;\n  background: var(--curio-card-bg, var(--curio-card-bg));\n  border-top: 1px solid var(--curio-border);\n}\n\n/* The skills `/` lists, above the composer, as wide as its row. */\n.skillMenu {\n  composes: thinScrollbar from \"../../../styles/scrollbars.module.css\";\n  position: absolute;\n  left: 16px;\n  right: 16px;\n  bottom: calc(100% + 4px);\n  z-index: 2;\n  max-height: 240px;\n  overflow-y: auto;\n  padding: 4px;\n  background: var(--curio-card-bg);\n  border: 1px solid var(--curio-border);\n  border-radius: 10px;\n  box-shadow: var(--curio-shadow-context-menu);\n}\n\n.skillMenuNote {\n  padding: 8px 10px;\n  font-size: 11.5px;\n  color: var(--curio-text-secondary, var(--curio-text-meta));\n}\n\n.skillOption {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 6px 10px;\n  border-radius: 7px;\n  cursor: pointer;\n}\n\n.skillOptionActive {\n  background: var(--curio-surface-muted);\n}\n\n.skillOptionName {\n  font-family: var(--curio-font-mono, ui-monospace, monospace);\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--curio-text-primary);\n}\n\n.skillOptionHeld {\n  font-family: var(--curio-font-family);\n  font-weight: 400;\n  color: var(--curio-text-muted, var(--curio-text-meta));\n}\n\n.skillOptionText {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  font-size: 11px;\n  line-height: 1.35;\n  color: var(--curio-text-secondary, var(--curio-text-meta));\n}\n\n.input {\n  flex: 1;\n  min-width: 0;\n  padding: 9px 14px;\n  border: 1px solid var(--curio-border);\n  /* Half the one-row height: renders as the same pill at a single line, a\n     rounded rectangle once the textarea grows — never a distorted stadium. */\n  border-radius: 18px;\n  font-size: 12.5px;\n  font-family: inherit;\n  line-height: 1.45;\n  background: var(--curio-surface-muted);\n  color: var(--curio-text-primary, var(--curio-text-primary));\n  /* Growth is content-driven (useAutoGrowTextarea) — no manual drag handle,\n     no scrollbar until the height cap is reached. */\n  resize: none;\n  overflow-y: hidden;\n}\n\n.input:focus {\n  outline: 2px solid var(--curio-accent-sky-fg, var(--curio-focus-ring));\n  outline-offset: 1px;\n  background: var(--curio-card-bg);\n}\n\n.send {\n  flex: none;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 50%;\n  background: var(--curio-accent-sky-fg, var(--curio-role-running-fg));\n  color: var(--curio-text-on-dark);\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.send:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ── structured content (memo dev/39) ──────────────────────────────────── */\n\n/* Markdown from the safe renderer: keep the bubble rhythm tight. */\n.msgAgent p {\n  margin: 0 0 6px;\n}\n.msgAgent p:last-child {\n  margin-bottom: 0;\n}\n.msgAgent pre {\n  background: var(--curio-card-bg);\n  border: 1px solid var(--curio-border);\n  border-radius: 8px;\n  padding: 8px 10px;\n  overflow-x: auto;\n  font-size: 0.8rem;\n}\n.msgAgent code {\n  font-size: 0.82em;\n}\n\n/* SUGGESTED PROMPTS chips (docs/03 soft-token treatment): filled soft\n   surfaces with hairlines, above the input row. */\n.suggestedRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px 0;\n  background: var(--curio-card-bg, var(--curio-card-bg));\n  border-top: 1px solid var(--curio-border);\n}\n\n.suggestedLabel {\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--curio-text-meta);\n  margin-right: 2px;\n}\n\n.suggestedChip {\n  border: 1px solid var(--curio-border);\n  background: var(--curio-surface-muted);\n  border-radius: 999px;\n  padding: 4px 12px;\n  font-size: 0.78rem;\n  color: var(--curio-text-primary);\n  cursor: pointer;\n  max-width: 260px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.suggestedChip:hover,\n.suggestedChip:focus-visible {\n  background: var(--curio-surface-muted);\n  border-color: var(--curio-border-strong);\n}\n\n/* The chips row visually joins the footer beneath it. */\n.suggestedRow + .footer {\n  border-top: none;\n}\n\n/* ── counter strip (memo dev/80, amended): the session's accumulated token\n   total, right-aligned by the composer (per-reply statuses live on the\n   messages). Fixed height so appearing/updating causes no layout shift. */\n.statusStrip {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 24px;\n  padding: 3px 16px;\n  background: var(--curio-card-bg, var(--curio-card-bg));\n  border-top: 1px solid var(--curio-border);\n}\n\n.statusStripSpacer {\n  flex: 1;\n}\n\n/* The strip joins whatever sits directly beneath/above it into one block. */\n.suggestedRow + .statusStrip,\n.statusStrip + .footer {\n  border-top: none;\n}\n\n/* ⚙ Attachment settings cog (memo dev/42) — a quiet labeled control at the\n   top of the content area, beneath the DEC-042 header. */\n.attachmentSettingsBtn {\n  align-self: flex-start;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid var(--curio-border);\n  background: var(--curio-surface-muted);\n  border-radius: 8px;\n  padding: 5px 12px;\n  font-size: 0.76rem;\n  color: var(--curio-text-secondary);\n  cursor: pointer;\n  min-height: 28px;\n}\n\n.attachmentSettingsBtn:hover,\n.attachmentSettingsBtn:focus-visible {\n  background: var(--curio-surface-muted);\n  border-color: var(--curio-border-strong);\n  color: var(--curio-text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `YSZGpjeZyMO8o4qSlaGn`,
	"panelPresented": `nfvdcfpsDwsC0InnAKu5`,
	"header": `hcY4HNioE016YOlKn9TF`,
	"headerRow": `Ghsu5p0srgAfVNes7LW_`,
	"headerSpacer": `hC4TH1jb7Kw9NiLCq7Qg`,
	"cycleBtn": `kGDpMf5kb8cufXJUtGAh`,
	"headerBot": `gRmdxq5C6qa9qFO3qbZ_`,
	"position": `sEDXNWYcDyPV3R7gHPHb`,
	"tint_node": `ROsXntDDUq291fOK6cK9`,
	"tint_canvas": `n7odiLlAHn_EDh7TrCJb`,
	"tint_data": `pertikFcLQSEZELlqjp9`,
	"tint_evaluate": `XYjBtr3GyfUTMav2I65K`,
	"tint_package": `jMWwV1J1MWEgWx9mZXgb`,
	"title": `jv1q9hWT8uKWu3gg_KYf`,
	"titleButton": `wjvsEW93W1MvoGCGqMOr`,
	"titleEditing": `_uyNmBqH16EQLFXnD2jo`,
	"titlePrefix": `rvhyVV791zndiyOpJVQ9`,
	"titleInput": `mB6z0aiwpgqzq0S_Biie`,
	"titleError": `o4TRbjIGJytS6ijRZLKd`,
	"subtitle": `Vpks_Ns38nT2a9I90hm4`,
	"headerBtn": `lY9CkUqBuGkk7QjaNnQA`,
	"intentMsg": `eL_q5QPwTakj5jbYZWLd`,
	"intentClamped": `kf8sGySUbjzTBSwwticY`,
	"intentPlaceholder": `tigkENMNqSFTl7_jyrC6`,
	"intentControls": `_ii0qpujfcKI4vvFxnKv`,
	"intentToggle": `g53jZyXBAlPWheofvZ4w`,
	"intentEdit": `Wln8T1ZRFGLfqRY5QehG`,
	"intentEditor": `v_RzWbnJ7rgB99vlaQml`,
	"intentTextarea": `RfHe9sRQvsyDV67Watm6`,
	"intentActions": `xfu3ojXS36aNANOUcQAN`,
	"intentSave": `W9SdFsg7riAVDlzfYDtA`,
	"intentCancel": `UEtDp7giFHR32Kpcg9kl`,
	"intentError": `wNctfAPfjlfyph4OpPoJ`,
	"messagesWrap": `juGm_zDGKQ7gSjWxCklf`,
	"messages": `HzxkNAL9uzS7QF0aH0LP`,
	"msgUser": `nAuyJD9v4phORomRzk7Z`,
	"userTurn": `ywED5rzAFo4cki8cTklz`,
	"msgWriter": `ARmNvfV8bVxth0gmMvH9`,
	"agentRow": `ReODflKISrUwjY_iYWqT`,
	"agentCol": `VmE69ReXgamHN_hiKdfO`,
	"turnMeta": `E0WwEtVOrndrB_qv2IwG`,
	"turnNote": `FBcFVbVJzqV1EPzg0xUv`,
	"turnSkills": `hruLuzu069u26XbI5prw`,
	"turnSkill": `ZJQOtwLf1cgHA_QPLBhu`,
	"agentRowAvatar": `JncX5AIR2d5vpJDhcKj7`,
	"msgAgent": `BpuQM2TNgLbhdUGJlJa9`,
	"msgError": `Bljkh8Q5pbofbH_HbAvg`,
	"systemLine": `T_HDqO5dhga3rYOpoNWd`,
	"systemError": `XodwB4s04VQvpk8tQTvK`,
	"retry": `D0ipVLSnmkuGeXde2QSy`,
	"footer": `qQm0wGQY9m9OpaU2GuVX`,
	"skillMenu": `pi3FjmBWpItxDcLZtXLE ${___CSS_LOADER_ICSS_IMPORT_0___.locals["thinScrollbar"]}`,
	"skillMenuNote": `HIkphSQez0JcidGxqFZi`,
	"skillOption": `VlBanzeirXAAnq2_SMgU`,
	"skillOptionActive": `dBbbMCmbLJDPEZXH0G6F`,
	"skillOptionName": `z1o1aJUpJl00m89aZQqw`,
	"skillOptionHeld": `o8QgVPGe5a4V6RE4U5gf`,
	"skillOptionText": `xoEDhPU3QOTPZXhdmKRY`,
	"input": `bDAyWVGQ9UaIy5jjyJet`,
	"send": `_0vRb9JnW7kK8IleEWWyg`,
	"suggestedRow": `TTqCzDniUREUnT0HKGHA`,
	"suggestedLabel": `pbV4FlOheKlgSgjL0h89`,
	"suggestedChip": `KsE0ANGSTPR43M6Ki0iA`,
	"statusStrip": `cOUYa2kuTn7DwORzkbaX`,
	"statusStripSpacer": `MbmRdKAmSUyuEskyUfOm`,
	"attachmentSettingsBtn": `tAreghSZSdseEyysHdSv`
};
export default ___CSS_LOADER_EXPORT___;
